<template>
  <v-app id="inspire">
    <v-navigation-drawer v-model="drawer" app>
      <div class="pt-2 pr-2 pl-2">
        <v-btn block dark @click="logout">
          <v-icon>mdi-logout</v-icon>登出</v-btn
        >
      </div>
      <v-list>
        <v-list-item
          v-for="(item, i) in items1"
          :key="'item1_' + i"
          link
          @click="changePage(item)"
        >
          <v-list-item-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ item.text }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <!--  -->
        <!-- <v-list-item>
          <v-list-item-content>
            <v-btn block dark @click="logout">
              <v-icon>mdi-logout</v-icon>登出</v-btn
            >
          </v-list-item-content>
        </v-list-item> -->
      </v-list>
      <!-- <v-btn block dark @click="logout" absolute bottom>
        <v-icon>mdi-logout</v-icon>登出
      </v-btn> -->
      <!--  -->
      <!-- <template v-slot:append>
        <div class="pa-2 mb-xs-4">
          <v-btn block dark @click="logout">
            <v-icon>mdi-logout</v-icon>登出</v-btn
          >
        </div>
      </template> -->
    </v-navigation-drawer>

    <v-app-bar app color="primary" dark>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
      <v-toolbar-title>{{ topLabel }}</v-toolbar-title>
    </v-app-bar>

    <v-content>
      <v-container class="pa-0 fill-height" fluid>
        <router-view @setTopLabel="setTopLabel" class="fill-height" />
        <!-- <v-row>
          <v-col class="text-center">
          </v-col>
        </v-row> -->
      </v-container>
    </v-content>
    <v-footer color="primary" app>
      <span class="white--text">&copy; {{ footerCopy }}</span>
    </v-footer>
  </v-app>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
  props: {
    source: String
  },
  data: () => {
    return {
      topLabel: 'Application',
      footerCopy: '2022',
      lists: [
        {
          text: '系統設定',
          path: 'system',
          level: 3,
          icon: 'mdi-cog'
        },
        {
          text: '公告設定',
          path: 'board',
          level: 3,
          icon: 'mdi-billboard'
        },
        {
          text: '零組件設定',
          path: 'addone',
          level: 3,
          icon: 'mdi-sitemap'
        },
        {
          text: '零組件瀏覽',
          path: 'addonelist',
          level: 3,
          icon: 'mdi-sitemap'
        },
        {
          text: '群組瀏覽',
          path: 'group',
          level: 6,
          icon: 'mdi-account-multiple'
        },
        {
          text: '群組溢價設定',
          path: 'groupdetail',
          level: 6,
          icon: 'mdi-format-list-group-plus'
        },
        {
          text: '報價單瀏覽',
          path: 'quote',
          level: 6,
          icon: 'mdi-order-bool-ascending-variant'
        },
        {
          text: '管理員帳號',
          path: 'admin',
          level: 2,
          icon: 'mdi-star-plus'
        },
        {
          text: '代理商帳號',
          path: 'agent',
          level: 3,
          icon: 'mdi-star'
        },
        {
          text: '會員帳號',
          path: 'member',
          level: 6,
          icon: 'mdi-star-outline'
        },
        {
          text: '會員申請瀏覽',
          path: 'mregister',
          level: 3,
          icon: 'mdi-star-minus-outline'
        }
      ],
      drawer: null
    }
  },
  computed: {
    ...mapState('account', ['level']),
    items1() {
      const o = []
      this.lists.forEach(e => {
        if (this.level <= e.level) {
          o.push(e)
        }
      })
      return o
    }
  },
  methods: {
    ...mapActions('account', ['logout']),
    changePage(item) {
      const path = item.path
      this.topLabel = item.text
      if (!path) return
      if (window.location.pathname === `/${path}`) return (this.drawer = false)
      this.$router.push({ name: path })
    },
    setTopLabel(idx) {
      this.topLabel = this.lists[idx].text
    }
  },
  created() {
    this.$nextTick(() => {
      this.items1.forEach(e => {
        if (window.location.pathname === `/${e.path}`) {
          this.topLabel = e.text
        }
      })
    })
  }
}
</script>

<style>
body {
  background-image: none !important;
}
</style>
